<template>
    <div id="menuHeader" :style="envColor">
        <div class="row">
            <div class="menuHeaderWrapper col-lg-7 col-md-6">
                <div id="logoRem3rch"><div class="logo"></div></div>
                <div class="linksWrapper  mobileNot">
                    <router-link
                        @click.native="trackEventMatomo('trackEvent', 'Menu header', 'link', $t('menuHeader.homeLink'))"
                        tag="div"
                        to="/"
                        exact
                        ><a id="homeId">{{ $t("menuHeader.homeLink") }}</a></router-link
                    >
                    <router-link
                        @click.native="trackEventMatomo('trackEvent', 'Menu header', 'link', $t('menuHeader.catalogueLink'))"
                        tag="div"
                        to="/catalog"
                        ><a id="catalogId">{{ $t("menuHeader.catalogueLink") }}</a></router-link
                    >
                    <router-link
                        @click.native="trackEventMatomo('trackEvent', 'Menu header', 'link', $t('menuHeader.planoLink'))"
                        tag="div"
                        v-if="hasAccessRead('plano_builder')"
                        :to="'/planos?campaign=' + currentCampaignId"
                        ><a> {{ $t("menuHeader.planoLink") }}</a></router-link
                    >
                    <router-link
                        @click.native="trackEventMatomo('trackEvent', 'Menu header', 'link', 'order manager')"
                        tag="div"
                        v-if="hasAccessRead('orders_manager') && false"
                        to="/list-orders"
                        ><a>ORDERS</a>
                    </router-link>
                    <router-link
                        @click.native="
                            forecastSetIsShowActiveOnly(false);
                            trackEventMatomo('trackEvent', 'Menu header', 'link', $t('menuHeader.forecastLink'));
                        "
                        tag="div"
                        v-if="canAccessLaunchForecast"
                        :to="forecastRoutes.BASE"
                        ><a>{{ $t("menuHeader.forecastLink") }}</a>
                    </router-link>
                    <router-link
                        @click.native="trackEventMatomo('trackEvent', 'Menu header', 'link', $t('menuHeader.catalogForecastLink'))"
                        tag="div"
                        v-if="canAccessCatalogForecast"
                        :to="catalogForecastLink"
                        ><a>{{ $t("menuHeader.catalogForecastLink") }}</a>
                    </router-link>
                    <div v-if="canAccessTools" class="dropdown" :class="isToolsLink() ? 'router-link-active' : ''">
                        <a class="dropbtn">{{ $t("menuHeader.tools.name") }}</a>
                        <div class="dropdown-content d-none">
                            <router-link
                                @click.native="trackEventMatomo('trackEvent', 'Menu header', 'link', $t('menuHeader.tools.manageUsers'))"
                                tag="a"
                                :to="'/users/user-list'"
                                v-if="canAccessToolsUsers"
                            >
                                {{ $t("menuHeader.tools.manageUsers") }}
                            </router-link>
                            <router-link
                                @click.native="trackEventMatomo('trackEvent', 'Menu header', 'link', $t('menuHeader.tools.manageZones'))"
                                tag="a"
                                :to="'/zones/zone-list'"
                                v-if="canAccessToolsZones"
                            >
                                {{ $t("menuHeader.tools.manageZones") }}
                            </router-link>
                            <router-link
                                @click.native="trackEventMatomo('trackEvent', 'Menu header', 'link', $t('menuHeader.tools.manageCampaigns'))"
                                tag="a"
                                :to="'/campaigns/campaign-list'"
                                v-if="canAccessToolsCampaigns"
                            >
                                {{ $t("menuHeader.tools.manageCampaigns") }}
                            </router-link>
                            <router-link
                                @click.native="trackEventMatomo('trackEvent', 'Menu header', 'link', $t('menuHeader.tools.exportExcel'))"
                                tag="a"
                                :to="'/exportExcel'"
                                v-if="canAccessToolsExportExcel"
                            >
                                {{ $t("menuHeader.tools.exportExcel") }}
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="mobileMenuWrapper mobileOnly tabletNot">
                    <div class="mobileOnly mobileMenu" @click="toggleMenu">
                        <span>{{ $t("menuHeader.menu") }}</span>
                    </div>
                    <nav class="cbp-spmenu cbp-spmenu-vertical cbp-spmenu-left menuOff" :class="{ menuOn: menuMobile }" id="cbp-spmenu-s1 mobileOnly">
                        <p class="abs pointer" id="closeMenu" @click="closeMenu">X</p>
                        <div class="linkContent">
                            <router-link to="/" exact
                                ><span @click="toggleMenu">{{ $t("menuHeader.homeLink") }}</span>
                            </router-link>
                            <router-link to="/catalog" exact
                                ><span @click="toggleMenu">{{ $t("menuHeader.catalogueLink") }}</span></router-link
                            >
                            <router-link :to="'/planos?campaign=' + currentCampaignId" exact
                                ><span @click="toggleMenu">{{ $t("menuHeader.planoLink") }}</span>
                            </router-link>
                        </div>
                        <selector-lang mobilemenu="true" classescss="select"></selector-lang>
                        <div class="select">
                            <select class="ff-light uppercase" @change="saveBrand" v-model="currentBrandId">
                                <option :value="null" class="uppercase">{{ $t("menuHeader.selectBrand") }}</option>
                                <option class="uppercase" v-for="brand in brands" :key="brand.id" :value="brand.id">{{ brand.name }} </option>
                            </select>
                        </div>
                        <div class="select">
                            <select class="ff-light uppercase" @change="saveZone" v-model="currentZone">
                                <option :value="null" class="uppercase">{{ $t("menuHeader.selectZone") }}</option>
                                <option class="uppercase" v-for="zone in zones" :key="zone.id" :value="zone.id">{{ zone.name }} </option>
                            </select>
                        </div>
                        <div class="select">
                            <select class="ff-light uppercase" @change="selectCampaign" v-model="currentCampaignId">
                                <option :value="0" v-if="currentCampaignId == '0'">{{ $t("catalogue.allCampaign") }} </option>
                                <option class="uppercase" v-for="campaign in campaigns" :key="campaign.id" :value="campaign.id"
                                    >{{ campaign.name }}
                                </option>
                            </select>
                        </div>
                    </nav>
                    <div class="user mobileOnly flexContainer fd-r cf">
                        <div class="pastille flexContainer fd-r ai-c ac-c">
                            <div class="textWrapper center">{{ rem3rchUser.user.initial }}</div>
                        </div>
                        <div class="arrowUser fright">
                            <a v-on:click="showArrow()" v-if="displayArrowUp" class="arrowLight fright pointer">
                                <img src="../../assets/chev_up_light.png" width="14" alt="" />
                            </a>
                            <a v-on:click="showArrow" v-if="displayArrowDown" class="arrowLight fright pointer">
                                <img src="../../assets/chev_down_light.png" width="14" alt="" />
                            </a>
                        </div>
                    </div>
                    <ul class="abs deco" v-if="displayArrowDown">
                        <li class="pointer" @click="openModalPreferences('preferencesModal')" v-b-modal="'preferencesModal'">
                            {{ $t("common.preferences") }}
                        </li>
                        <li class="pointer" v-setUserInfo.logout>{{ $t("common.deconnexion") }}</li>
                    </ul>
                </div>
            </div>
            <div class="userWrapper col-lg-5 col-md-6 mobileNot">
                <BasketMenu></BasketMenu>
                <div class="dropdown itemMenuContainer">
                    <button
                        class="myPDF btn-default dropdown-toggle"
                        type="button"
                        id="dropdownMenu1"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="true"
                        @click="openList()"
                    >
                        MY BOOK PDF
                    </button>
                    <ul v-if="openLists === true" class="abs ulDropdown" aria-labelledby="dropdownMenu1">
                        <li @click="openBook('export')" class="liDropdown"><a>All books</a></li>
                        <li v-for="(n, index) in getWishList" :key="n.id" @click="openBook(index)" class="liDropdown">
                            <a>{{ n.name }}</a>
                        </li>
                    </ul>
                </div>
                <router-link class="ml-2 mr-4 help-link" to="/help" exact>
                    <span>{{ $t("menuHeader.help") }}</span>
                </router-link>
                <selector-lang style="margin-top: 3px;"></selector-lang>
                <div class="user rel">
                    <div class="pastille flexContainer fd-r ai-c ac-c cf">
                        <div class="textWrapper initial">{{ rem3rchUser.user.initial }}</div>
                        <div class="arrowUser fright">
                            <a v-on:click="showArrow" v-if="displayArrowUp" class="arrowLight fright pointer">
                                <img src="../../assets/chev_up_light.png" width="14" alt="" />
                            </a>
                            <a v-on:click="showArrow" v-if="displayArrowDown" class="arrowLight fright pointer">
                                <img src="../../assets/chev_down_light.png" width="14" alt="" />
                            </a>
                        </div>
                    </div>
                    <ul class="abs deco" v-if="displayArrowDown">
                        <li class="pointer" @click="openModalPreferences('preferencesModal')" v-b-modal="'preferencesModal'">
                            {{ $t("common.preferences") }}
                        </li>
                        <li class="pointer" @click="openModalAbonnement">{{ $t("abonnement.title") }}</li>
                        <li
                            v-if="
                                hasAccessByProfile(PROFILES.FORECAST_MANAGER, APPLICATION.FORECAST_ID) ||
                                    hasAccessByProfile(PROFILES.ZONES_SUPERVISOR, APPLICATION.FORECAST_ID) ||
                                    hasAccessByProfile(PROFILES.FORECAST_MANAGER, APPLICATION.CATALOG_FORECAST_ID) ||
                                    hasAccessByProfile(PROFILES.ZONES_SUPERVISOR, APPLICATION.CATALOG_FORECAST_ID)
                            "
                        >
                            <div class="d-flex justify-content-between align-items-center">
                                <label class="switch" for="switchGod">
                                    <input type="checkbox" id="switchGod" v-model="godMode" @change="activeGodMode()" />
                                    <span class="slider round"></span>
                                </label>
                                <div>{{ $t("menuHeader.godMode") }}</div>
                            </div>
                        </li>
                        <li class="pointer" v-setUserInfo.logout>{{ $t("common.deconnexion") }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <modalBook v-if="modalBook" @hideBookModal="modalClose($event)"></modalBook> <WishList v-if="isDisplay"></WishList>
        <Preferences @close="isHidden = true" v-if="!isHidden" :action="dataAction"></Preferences>
        <Abonnement v-if="abonnement" @hideAbonnementModal="modalClose($event)"></Abonnement>
        <div class="godMode" v-if="godMode">
            <div class="text-god">
                <span>
                    God <br />
                    Mode
                </span>
            </div>
        </div>
        <GodModeModal v-if="godModeModal" @closed="reloadGodMode()" />
    </div>
</template>
<script>
import { PROFILES } from "@/plugins/AccessUserPlugin";
import { mapGetters, mapActions, mapState } from "vuex";
import SelectorLang from "../../components/langSelector/langSelector.vue";
import { setUser } from "@/directives/setUser";
import Globals from "../globals";
import modalBook from "../wishlist/modalBook";
import WishList from "../wishlist/WishList";
import connectionBO from "../../services/connectionBO";
import httpService from "../../components/service";
import Abonnement from "../modal/Abonnement";
import BasketMenu from "../BasketMenu/BasketMenu";
import Preferences from "@/components/header/preferences/Preferences";
import cacheService from "@/services/cache";
import { ROUTES as forecastRoutes } from "@/components/forecasts/router";
import { ROUTES as catalogForecastRoutes } from "@/components/catalogForcast/router";
import { FUNCTIONALITY as forecastFunctionality } from "@/components/forecasts/constants";
import { FUNCTIONALITY as catalogForecastFunctionality } from "@/components/catalogForcast/constants";
import session from "@/services/session";
import GodModeModal from "@/components/header/GodModeModal";
import { APPLICATION } from "@/components/admin/brand/constant";
import { EVENT_TYPE, OBJECT_TYPE, SHORT_DESCRIPTION } from "@/components/history/constants";
import historyService from "../../services/history";
import { FUNCTIONALITY } from "@/components/tools/constants";
import userService from "@/services/user";

const d3 = require("d3");

export default {
    components: {
        selectorLang: SelectorLang,
        modalBook,
        WishList,
        httpService,
        connectionBO,
        Abonnement,
        BasketMenu,
        Preferences,
        GodModeModal
    },
    data: () => ({
        OBJECT_TYPE,
        SHORT_DESCRIPTION,
        EVENT_TYPE,
        abonnement: false,
        menuMobile: false,
        rem3rchUser: {},
        displayArrowUp: true,
        displayArrowDown: false,
        currentZone: cacheService.getCurrentZoneId(),
        currentBrandId: cacheService.getCurrentBrandId(),
        currentCampaignId: cacheService.getCurrentCampaignId(),
        zones: [],
        brands: [],
        campaigns: [],
        modalBook: false,
        isHidden: true,
        dataAction: "",
        preferencesUsers: {},
        openLists: false,
        svg: null,
        forecastRoutes,
        forecastFunctionality,
        catalogForecastRoutes,
        catalogForecastFunctionality,
        PROFILES,
        godMode: false,
        godModeModal: false,
        APPLICATION
    }),
    directives: {
        setUser
    },
    watch: {
        async currentBrand() {
            const domXml = await Globals.loadSvg("/static/assets/rem3rch_logo.svg");
            this.svg = domXml;
            const logoEl = document.querySelector(".logo");
            if (!logoEl) return;
            logoEl.innerHTML = "";
            logoEl.appendChild(this.svg);
            d3.select(this.svg)
                .attr("width", 100)
                .attr("height", 50);
            d3.select(this.svg)
                .select(".cls-2")
                .style("fill", this.currentBrand.brandColors.color3);
        }
    },
    methods: {
        ...mapActions({
            setBook: "catalog/wishlist/setBook",
            setDisplay: "catalog/wishlist/setDisplay",
            setModeWishList: "catalog/wishlist/setMode",
            searchList: "catalog/wishlist/searchList"
        }),
        ...mapActions("forecast", { forecastSetIsShowActiveOnly: "setIsShowActiveOnly" }),
        isToolsLink() {
            return this.$route.path.includes("users/") || this.$route.path.includes("zones/") || this.$route.path.includes("campaigns/");
        },
        activeGodMode() {
            session.setValueSession("godMode", this.godMode);
            if (this.godMode == true) {
                userService
                    .godMode()
                    .then(() => {
                        this.godModeModal = true;
                    })
                    .catch(() => {
                        this.godModeModal = false;
                        session.setValueSession("godMode", false);
                    });
            } else {
                location.reload();
            }
        },
        openModalAbonnement() {
            this.abonnement = true;
            this.closeUserMenu();
        },
        openModalPreferences: function(action) {
            this.dataAction = {
                action: action,
                preferencesUsers: this.preferencesUsers
            };
            this.isHidden = false;
            this.$root.$emit("bv::show::modal", "preferencesModal");
            this.closeUserMenu();
        },
        // Ferme le menu des préférences, abonnement, Godmode et déconnexion utilisateur
        closeUserMenu() {
            this.displayArrowDown = false;
            this.displayArrowUp = true;
        },
        openList() {
            this.openLists = !this.openLists;
        },
        openBook(index) {
            if (index === "export") {
                this.setModeWishList("export");
                this.openLists = false;
                this.setDisplay(true);
            } else {
                this.modalBook = true;
                this.openLists = false;
                if (this.getWishList[index].data !== null) {
                    this.setBook(this.getWishList[index]);
                } else {
                    this.setBook({ vide: this.getWishList[index].name });
                }
            }
        },
        modalClose(close) {
            this.modalBook = close;
            this.abonnement = close;
        },
        saveBrand() {
            for (let i in this.brands) {
                if (this.brands[i].id === this.currentBrandId) {
                    cacheService.set("currentBrandId", this.brands[i].id);
                }
            }
            location.reload();
        },
        saveZone() {
            for (let i in this.zones) {
                if (this.zones[i].id === this.currentZone) {
                    cacheService.set("currentZoneId", this.zones[i].id);
                }
            }
            location.reload();
        },
        selectCampaign() {
            for (let i in this.campaigns) {
                if (this.campaigns[i].id === this.currentCampaignId) {
                    cacheService.set("currentCampaignId", this.campaigns[i].id);
                }
            }
            location.reload();
        },
        toggleMenu() {
            this.menuMobile = !this.menuMobile;
        },
        closeMenu() {
            this.menuMobile = false;
        },
        showArrow() {
            this.displayArrowUp = !this.displayArrowUp;
            this.displayArrowDown = !this.displayArrowDown;
        },
        reloadGodMode() {
            this.godModeModal = false;
            location.reload();
        }
    },
    computed: {
        ...mapGetters({
            getBrand: "brand/getBrand",
            getLogoRem3rch: "brand/getLogoRem3rch",
            getBackgroundColor: "brand/getBackgroundColor",
            isDisplay: "catalog/wishlist/isDisplay",
            getMode: "catalog/wishlist/isDisplay",
            getWishList: "catalog/wishlist/getLists"
        }),
        ...mapState("currentUser", ["currentBrand"]),
        envColor() {
            return process.env.ENV_COLOR ? { borderWidth: "5px", borderColor: process.env.ENV_COLOR } : null;
        },
        isForecastManager() {
            return (
                this.hasAccessByProfile(PROFILES.FORECAST_MANAGER, APPLICATION.FORECAST_ID) ||
                this.hasAccessByProfile(PROFILES.FORECAST_MANAGER, APPLICATION.CATALOG_FORECAST_ID)
            );
        },
        isSuperOrClientAdmin() {
            return this.isSuperAdmin() || this.isClientAdmin();
        },
        catalogForecastLink() {
            if (this.isSuperAdmin() || this.hasAccessByProfile(PROFILES.COORDINATOR, APPLICATION.CATALOG_FORECAST_ID)) {
                return catalogForecastRoutes.BASE + "/dashboard";
            }
            return catalogForecastRoutes.BASE + "/market";
        },
        canAccessLaunchForecast() {
            return (
                this.hasAccessRead(forecastFunctionality, [APPLICATION.FORECAST_ID]) &&
                (this.hasAccessByProfile(PROFILES.FORECAST_MANAGER, APPLICATION.FORECAST_ID) ||
                    this.hasAccessByProfile(PROFILES.ZONES_SUPERVISOR, APPLICATION.FORECAST_ID) ||
                    this.hasAccessByProfile(PROFILES.ZONE_FORECASTER, APPLICATION.FORECAST_ID) ||
                    this.hasAccessByProfile(PROFILES.ZONE_READER, APPLICATION.FORECAST_ID))
            );
        },
        canAccessCatalogForecast() {
            return (
                this.hasAccessRead(catalogForecastFunctionality, [APPLICATION.CATALOG_FORECAST_ID]) &&
                (this.hasAccessByProfile(PROFILES.FORECAST_MANAGER, APPLICATION.CATALOG_FORECAST_ID) ||
                    this.hasAccessByProfile(PROFILES.ZONES_SUPERVISOR, APPLICATION.CATALOG_FORECAST_ID) ||
                    this.hasAccessByProfile(PROFILES.COORDINATOR, APPLICATION.CATALOG_FORECAST_ID) ||
                    this.hasAccessByProfile(PROFILES.ZONE_FORECASTER, APPLICATION.CATALOG_FORECAST_ID))
            );
        },
        canAccessTools() {
            return (
                this.isSuperOrClientAdmin ||
                ((this.hasAccessUpdate(FUNCTIONALITY.CAMPAIGN, [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID]) ||
                    this.hasAccessUpdate(FUNCTIONALITY.USER, [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID]) ||
                    this.hasAccessUpdate(FUNCTIONALITY.ZONE, [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID])) &&
                    this.hasAccessToolsProfiles)
            );
        },
        canAccessToolsUsers() {
            return (
                this.isSuperOrClientAdmin ||
                (this.hasAccessUpdate(FUNCTIONALITY.USER, [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID]) && this.hasAccessToolsProfiles)
            );
        },
        canAccessToolsZones() {
            return (
                this.isSuperOrClientAdmin ||
                (this.hasAccessUpdate(FUNCTIONALITY.ZONE, [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID]) && this.hasAccessToolsProfiles)
            );
        },
        canAccessToolsCampaigns() {
            return (
                this.isSuperOrClientAdmin ||
                (this.hasAccessUpdate(FUNCTIONALITY.CAMPAIGN, [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID]) &&
                    this.hasAccessToolsProfiles)
            );
        },
        canAccessToolsExportExcel() {
            return this.isSuperOrClientAdmin;
        },
        hasAccessToolsProfiles() {
            return (
                this.hasAccessByProfile(PROFILES.FORECAST_MANAGER, APPLICATION.FORECAST_ID) ||
                this.hasAccessByProfile(PROFILES.FORECAST_MANAGER, APPLICATION.CATALOG_FORECAST_ID) ||
                this.hasAccessByProfile(PROFILES.ZONES_SUPERVISOR, APPLICATION.FORECAST_ID) ||
                this.hasAccessByProfile(PROFILES.ZONES_SUPERVISOR, APPLICATION.CATALOG_FORECAST_ID) ||
                this.hasAccessByProfile(PROFILES.COORDINATOR, APPLICATION.FORECAST_ID) ||
                this.hasAccessByProfile(PROFILES.COORDINATOR, APPLICATION.CATALOG_FORECAST_ID)
            );
        }
    },
    created() {
        /**
         * Return preference User
         * @returns {Promise<any>}
         */
        connectionBO
            .getPreferences()
            .then(v => {
                this.preferencesUsers = v;
            })
            .then(() => {
                if (!this.preferencesUsers.preference.activated) {
                    this.openModalPreferences("preferencesModal");
                }
            });
        this.searchList();
        this.$store.dispatch("brand/populate");
        this.rem3rchUser = cacheService.getRem3rchUser();
        this.brands = cacheService.getBrands();
        let currentBrand = this.brands.find(b => b.id === this.currentBrandId);
        this.zones = currentBrand.zones;
        this.campaigns = currentBrand.campaigns;
        this.currentCampaignId = cacheService.getCurrentCampaignId();
        this.godMode = session.getValueSession("godMode") != null ? JSON.parse(session.getValueSession("godMode")) : false;
    }
};
</script>
<style scoped lang="scss">
@import "../../assets/css/themes.scss";

.ulDropdown {
    z-index: 2;
    width: 160%;
    .liDropdown {
        list-style: none;
        color: white;
        background-color: black;
        padding: 6px;
    }
}
.itemMenuContainer {
    padding: 0 10px;
    display: inline-block;
}
.myPDF {
    display: inline-block;
    background-color: #a8a8a8;
    color: #ffffff;
    border: none;
    text-transform: uppercase;
    border-radius: 15px;
    padding: 5px 8px;
    font-size: 12px;
}

#app {
    background: red !important;
}

#menuHeader {
    position: relative;
    padding: 0 20px;
    background-color: map_get($dark, second-background);
    border-top: 0px pink solid;
    .linksWrapper {
        font-size: 1.4rem;
        display: table-cell;
        vertical-align: middle;
        @media screen and (max-width: 767px) {
            display: none;
        }
        a {
            color: #95989a;
            text-transform: uppercase;
            text-decoration: none;
            margin: 0 20px;
            display: block;
            @media only screen and (max-width: 992px) {
                margin: 0 12px;
                font-size: 12px;
            }
            &:hover {
                color: #fff;
                transition: all 0.3s;
            }
        }
        div {
            height: 54px;
            padding-top: 20px;
            display: table-cell;
            text-align: center;
            border-bottom: 2px transparent solid;
            &:hover {
                transition: all 0.3s;
                border-bottom: 2px #fff solid;
            }
        }
        .router-link-active {
            font-weight: bold;
            border-bottom: 2px #fff solid;
            > a {
                color: #fff;
            }
        }
    }
    #closeMenu {
        right: 15px;
    }
}

.userWrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 25px 0;

    .help-link {
        color: #95989a;
        text-decoration: none;
        &:hover {
            color: #fff;
        }
    }
}

#logoRem3rch {
    padding-right: 20px;
    display: table-cell;
    @media screen and (max-width: 767px) {
        display: block;
        text-align: center;
    }
}

.user {
    margin: 0;
    display: inline-block;
    @media screen and (max-width: 767px) {
        display: flex;
        max-width: 70px;
        right: 0;
        position: absolute;
        top: -5px;
    }
    .pastille {
        background-color: white;
        border-radius: 15px;
        font-size: 1.4rem;
        height: 30px;
        width: 30px;
    }
}

.book {
    margin: 10px 10px 0 0;
    select {
        background-color: transparent;
        border: none;
        color: white;
    }
}

@media only screen and (max-width: 767px) {
    .mobileMenuWrapper {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 15px;
        left: 0;
        .cbp-spmenu {
            background: #f4f4f4;
            position: fixed;
            box-shadow: 0.5rem 0 10px -5px rgba(0, 0, 0, 0.23);
        }

        .cbp-spmenu a {
            display: block;
            color: black;
            font-size: 14px;
            font-family: Roboto;
            font-weight: 300;
            text-decoration: none;
        }
        .cbp-spmenu-vertical {
            width: 240px;
            height: 100%;
            top: 45px;
            z-index: 100;
            a {
                padding: 10px 30px;
                text-transform: uppercase;
                &:first-child {
                    padding-top: 25px;
                }
                &:last-child {
                    padding-bottom: 25px;
                    border-bottom: 1px solid #343434;
                }
            }
            .select {
                padding: 20px 25px 0px 20px;
                select {
                    width: 100%;
                    font-size: 1.4rem;
                    border: none;
                    background-color: #f4f4f4;
                }
            }

            .selectedBrand {
                margin: 0px 30px;
                font-size: 1.4rem;
                padding-top: 20px;
            }
        }

        .cbp-spmenu-left {
            left: -240px;
        }
        .cbp-spmenu-left.cbp-spmenu-open {
            left: 0px;
        }
        .cbp-spmenu-push {
            overflow-x: hidden;
            position: relative;
            left: 0;
        }
        .menuOff {
            left: -240px;
        }
        .menuOn {
            left: 0px;
        }
        .cbp-spmenu,
        .cbp-spmenu-push {
            -webkit-transition: all 0.3s ease;
            -moz-transition: all 0.3s ease;
            transition: all 0.3s ease;
        }
    }
    .mobileMenu {
        color: white;
        font-size: 1.3rem;
        background: transparent url("/static/img/mobileMenu.burger.png") no-repeat left center;
        padding: 0 0 0 25px;
        margin: 0 0 0 10px;
    }
    .arrowLight {
        img {
            width: 9px;
            margin-top: 13px;
        }
    }
}

.deco {
    top: calc(2px + 100%);
    //transform: translateY(25%);
    right: -20px;
    z-index: 100;
    background-color: black;
    padding-left: 0;
    width: 147px;
    height: auto;
    li {
        list-style: none;
        padding: 5px;
        font-size: 14px;
        color: white;
        padding-left: 15px;
        font-family: Roboto;
        border-bottom: 1px dotted white;
        &:last-child {
            border-bottom: none;
        }
        &:hover {
            background-color: #007aff;
        }
    }
}

.arrowUser {
    margin-left: 6px;
}

.initial {
    margin: 0 6px;
}

.arrowLight {
    img {
        width: 7px;
    }
}

.switch {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 17px;
    margin: 0;
    input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 17px;

        &:before {
            position: absolute;
            content: "";
            height: 13px;
            width: 13px;
            left: 2px;
            bottom: 2px;
            background-color: white;
            -webkit-transition: 0.4s;
            transition: 0.4s;
            border-radius: 50%;
        }
    }

    input:checked + .slider {
        background-color: red;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px red;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(13px);
        -ms-transform: translateX(13px);
        transform: translateX(13px);
    }
}

.godMode {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 4px solid red;
    pointer-events: none;
    .text-god {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 150px;
        height: 150px;
        z-index: 1;
        span {
            text-align: center;
            position: absolute;
            right: 15px;
            bottom: 15px;
            color: white;
            font-weight: 400;
            font-size: 17px;
            text-transform: capitalize;
        }
        &:before {
            content: "";
            height: 100%;
            width: 100%;
            position: absolute;
            border-bottom: 150px solid red;
            border-left: 150px solid transparent;
            z-index: -1;
        }
    }
}

.dropdown {
    position: relative;
    display: inline-block;
    .dropdown-content:hover,
    &:hover .dropdown-content {
        display: block !important;
    }
    .dropdown-content {
        border-top: 1px solid #333333;
        display: none;
        position: absolute;
        padding: 0 !important;
        top: calc(100% + 2px);
        left: 50%;
        transform: translate(-50%, 0);
        z-index: 1;
        a {
            border-top: 1px solid #95989a;
            margin: 0 !important;
            width: 200px;
            background-color: #333333;
            padding: 15px 0;
            &:hover {
                text-decoration: none;
                display: block;
            }
            &.router-link-active {
                border-bottom: none !important;
                color: #fff !important;
            }
        }
        &:focus {
            display: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// MenuHeader.vue?7ca12ed3